import { Chart, BarController, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { TranslationService } from '../../react/services/translation.service';

Chart.register(BarController, BarElement, CategoryScale, LinearScale);
Chart.register(ChartDataLabels);

if (document.getElementsByClassName('fw-climate-calculator').length > 0) {
  const emissionsPerKmFromManufacturingElectricBus = 146;
  const emissionsPerKmFromManufacturingElectricCar = 51;
  const emissionsPerKmFromManufacturingFossilFuelCar = 32;

  const emissionsPerKmFromDrivingFossilFuelCar = 150;
  const emissionsPerKmFromDrivingElectricCar = 7;
  const emissionsPerKmFromDrivingElectricBus = 35;

  const ctx = document.getElementById('climate-calculator-chart') as HTMLCanvasElement;

  const translationElectricBus = TranslationService.get('climatecalculator.electricbus');
  const translationElectricCar = TranslationService.get('climatecalculator.electriccar');
  const translationFossilFuelCar = TranslationService.get('climatecalculator.fossilfuelcar');
  const translationAriaGraphDescriptionTemplate = TranslationService.get('climatecalculator.ariagraphdescription');

  new Chart(ctx, {
    type: 'bar',
    data: {
      labels: [translationElectricBus, translationElectricCar, translationFossilFuelCar],
      datasets: [
        {
          data: [0, 0, 0],
          backgroundColor: ['#0079B4', '#111111', '#A2191F'],
          datalabels: {
            color: ['#0079B4', '#111111', '#A2191F'],
            anchor: 'end',
            align: 'top',
            font: { size: 39, weight: 'bold' },
            formatter: (value) => `${value} g`,
          },
        },
      ],
    },
    options: {
      responsive: true,
      scales: { x: { grid: { display: false }, ticks: { color: '#3c4650', font: { size: 17 } } }, y: { display: false } },
      layout: { padding: { top: 50 } },
      hover: { mode: undefined },
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
      },
    },
  });

  const getSelectedValue = (controlId: string): number => {
    const control = document.getElementById(controlId) as HTMLSelectElement;
    return parseInt(control.options[control.selectedIndex].value, 10);
  };

  const createAriaLiveText = (
    paxElectricBus: number,
    emissionElectricBus: number,
    paxElectricCar: number,
    emissionElectricCar: number,
    paxFossilFuelCar: number,
    emissionFossilFuelCar: number
  ): string =>
    translationAriaGraphDescriptionTemplate
      .replace('#paxElectricBus#', paxElectricBus.toString())
      .replace('#emissionElectricBus#', emissionElectricBus.toString())
      .replace('#paxElectricCar#', paxElectricCar.toString())
      .replace('#emissionElectricCar#', emissionElectricCar.toString())
      .replace('#paxFossilFuelCar#', paxFossilFuelCar.toString())
      .replace('#emissionFossilFuelCar#', emissionFossilFuelCar.toString());

  const updateChart = () => {
    const paxElectricBus = getSelectedValue('pax-electric-bus');
    const paxElectricCar = getSelectedValue('pax-electric-car');
    const paxFossilFuelCar = getSelectedValue('pax-fossil-fuel-car');
    const emissionElectricBus = Math.round((emissionsPerKmFromManufacturingElectricBus + emissionsPerKmFromDrivingElectricBus) / paxElectricBus);
    const emissionElectricCar = Math.round((emissionsPerKmFromManufacturingElectricCar + emissionsPerKmFromDrivingElectricCar) / paxElectricCar);
    const emissionFossilFuelCar = Math.round((emissionsPerKmFromManufacturingFossilFuelCar + emissionsPerKmFromDrivingFossilFuelCar) / paxFossilFuelCar);

    const chart = Chart.getChart(ctx);
    if (chart) {
      chart.data.datasets[0].data = [emissionElectricBus, emissionElectricCar, emissionFossilFuelCar];
    }
    chart?.update();

    const graphDescription = document.getElementById('graph-description');
    if (graphDescription) {
      graphDescription.innerHTML = createAriaLiveText(paxElectricBus, emissionElectricBus, paxElectricCar, emissionElectricCar, paxFossilFuelCar, emissionFossilFuelCar);
    }
  };

  document.querySelectorAll('select').forEach((control) => {
    control.addEventListener('change', updateChart);
  });

  updateChart();
}
